/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IProductDetailBlockData } from './product-detail-block.data';
import { IProductDetailBlockProps } from './product-detail-block.props.autogenerated';
import { INodeProps } from '@msdyn365-commerce-modules/utilities';
export interface IProductDetailBlockViewProps extends IProductDetailBlockProps<IProductDetailBlockData> {
    name: string;
    description: string;
    customClass: string;
    MediaGalleryContainerProps: INodeProps;
    mediaGallery?: React.ReactNode;
}

/**
 *
 * ProductDetailBlock component
 * @extends {React.PureComponent<IProductDetailBlockProps<IProductDetailBlockData>>}
 */
class ProductDetailBlock extends React.PureComponent<IProductDetailBlockProps<IProductDetailBlockData>> {
    public render(): JSX.Element | null {
        
        const ProductDetailBlockViewProps = {
            ...this.props,
            name: this.props.config.productName ? this.props.config.productName : 'N/A',
            description: this.props.config.productDesc ? this.props.config.productDesc : 'N/A',
            customClass: this.props.config.className ? this.props.config.className : '',
            mediaGallery: this.props.slots.mediaGallery && this.props.slots.mediaGallery.length > 0 ? this.props.slots.mediaGallery[0] : undefined,
            MediaGalleryContainerProps: {
                className: 'ms-media-gallery'
            }
        }
            
        return this.props.renderView(ProductDetailBlockViewProps);
    }
}

export default ProductDetailBlock;
